import { Loader } from "dash-styled"
import React, { Suspense, forwardRef } from "react"
import type { SchemaFormProps, SchemaFormRefProps } from "resha"

const ReshaSchemaForm = React.lazy(async () => {
    return import("resha").then(resha => ({
        default: resha.SchemaForm
    }))
})

export const SchemaForm = forwardRef<SchemaFormRefProps, SchemaFormProps>(
    (props, ref) => (
        <Suspense fallback={<Loader size="xxxl" />}>
            <ReshaSchemaForm ref={ref} {...props} />
        </Suspense>
    )
)
